/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSpring, animated } from "@react-spring/web";
import { createUseGesture, dragAction, pinchAction } from "@use-gesture/react";
import { useDispatch, useSelector } from "react-redux";

import {
  setInBoundCallPopUpShow,
  setInBoundCallPopUpVisibility,
  setMinimizePopUpInnerData,
  setMinimizePopUpShow,
} from "./component/redux/callSlice";
import Iframe from "./component/sidebar/Iframe";
import { HangupCall } from "./component/Helpers/Lib";

export default function TestConference() {
  const dispatch = useDispatch();
  let text = "";
  const {
    minimizePopUpShow,
    minimizePopUpInnerData,
    inBoundCallPopUpVisibility,
    inBoundCallPopUpShow,
  } = useSelector((state) => state.call);
  const [room, setRoom] = useState("");
  const [callerName, setCallerName] = useState("");
  const useGesture = createUseGesture([dragAction, pinchAction]);
  const MinimizePopUpHandler = async () => {
    dispatch(
      setMinimizePopUpInnerData({ callerName: room, callType: "inbound" }),
    );
    dispatch(setInBoundCallPopUpVisibility(true));
    dispatch(setMinimizePopUpShow(true));
  };
  const allAttendeeList = [{ user_id: "sdsdse23232", name: "test" }];
  const callDetails = { monitor_status: false };

  useEffect(() => {
    const { callerName } = minimizePopUpInnerData;
    setCallerName(callerName);
  });

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    document.addEventListener("gesturestart", handler);
    document.addEventListener("gesturechange", handler);
    return () => {
      document.removeEventListener("gesturestart", handler);
      document.removeEventListener("gesturechange", handler);
    };
  }, []);

  const [style, api] = useSpring(() => ({
    x: 0,
    y: 0,
    scale: 1,
    rotateZ: 0,
  }));
  const ref = React.useRef(null);

  useGesture(
    {
      onDrag: ({ pinching, cancel, offset: [x, y] }) => {
        if (pinching) return cancel();
        api.start({ x, y });
      },
      onPinch: ({
        origin: [ox, oy],
        first,
        movement: [ms],
        offset: [s, a],
        memo,
      }) => {
        if (first) {
          const { width, height, x, y } = ref.current.getBoundingClientRect();
          const tx = ox - (x + width / 2);
          const ty = oy - (y + height / 2);
          memo = [style.x.get(), style.y.get(), tx, ty];
        }

        const x = memo[0] - ms * memo[2];
        const y = memo[1] - ms * memo[3];
        api.start({ scale: s, rotateZ: a, x, y });
        return memo;
      },
    },
    {
      target: ref,
      drag: { from: () => [style.x.get(), style.y.get()] },
      pinch: { scaleBounds: { min: 0.5, max: 2 }, rubberband: true },
    },
  );

  const DeclineCall = () => {
    HangupCall();
    dispatch(setInBoundCallPopUpShow(false));
    dispatch(setInBoundCallPopUpVisibility(false));
    dispatch(setMinimizePopUpShow(false));
  };

  const MinimizePopUp = () => {
    return (
      <>
        <animated.div className="call-cut-div" ref={ref} style={style}>
          <span className="caller-name">{callerName}</span>

          <div
            className="minimize-restore-icons"
            onClick={() => {
              dispatch(setMinimizePopUpShow(false));
              dispatch(setInBoundCallPopUpVisibility(false));
            }}
          >
            <svg
              viewBox="0 0 24 24"
              width="24"
              height="24"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="css-i6dzq1"
            >
              <polyline points="15 3 21 3 21 9"></polyline>
              <polyline points="9 21 3 21 3 15"></polyline>
              <line x1="21" y1="3" x2="14" y2="10"></line>
              <line x1="3" y1="21" x2="10" y2="14"></line>
            </svg>
          </div>

          <a className="call-cut-div-icons" onClick={() => DeclineCall()}>
            <svg height="22" width="22" viewBox="0 0 32 32">
              {" "}
              <path d="M16 12c-2.125 0-4.188.313-6.125.938v4.125c0 .5-.313 1.063-.75 1.25a13.87 13.87 0 00-3.563 2.438c-.25.25-.563.375-.938.375s-.688-.125-.938-.375L.373 17.438c-.25-.25-.375-.563-.375-.938s.125-.688.375-.938c4.063-3.875 9.563-6.25 15.625-6.25s11.563 2.375 15.625 6.25c.25.25.375.563.375.938s-.125.688-.375.938l-3.313 3.313c-.25.25-.563.375-.938.375s-.688-.125-.938-.375a13.87 13.87 0 00-3.563-2.438c-.438-.188-.75-.625-.75-1.188V13c-1.938-.625-4-1-6.125-1z"></path>
            </svg>
          </a>
        </animated.div>
      </>
    );
  };

  const header = () => {
    return (
      <>
        <input
          name="room"
          type="text"
          onChange={(event) => {
            text = event.target.value;
          }}
        />
        <button
          onClick={(event) => {
            event.preventDefault();
            if (text !== "") setRoom(text);
            dispatch(setInBoundCallPopUpShow(true));
          }}
        >
          Join
        </button>
        <button
          onClick={(event) => {
            event.preventDefault();
            HangupCall().then(() => {
              dispatch(setInBoundCallPopUpShow(false));
              dispatch(setInBoundCallPopUpVisibility(false));
              dispatch(setMinimizePopUpShow(false));
            });
          }}
        >
          Hangup
        </button>
      </>
    );
  };
  if (room !== "" && inBoundCallPopUpShow) {
    return (
      <>
        {header()}
        <Modal
          show={true}
          className={`modal-full width-modal align-items-center justify-content-center ${
            inBoundCallPopUpVisibility ? "visibility-hidden" : ""
          }`}
          backdrop="static"
          keyboard="False"
        >
          <Modal.Header>
            <Modal.Title></Modal.Title>
            <button
              className="maximize-restore-icons minimizePopupButton icon_container"
              onClick={() => MinimizePopUpHandler()}
            >
              <svg
                viewBox="0 0 24 24"
                width="24"
                height="24"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="css-i6dzq1"
              >
                <polyline
                  points="4 14 10 14 10 20"
                  stroke="#b8c0c9"
                  fill="none"
                ></polyline>
                <polyline
                  points="20 10 14 10 14 4"
                  stroke="#b8c0c9"
                  fill="none"
                ></polyline>
                <line
                  x1="14"
                  y1="10"
                  x2="21"
                  y2="3"
                  stroke="#b8c0c9"
                  fill="none"
                ></line>
                <line
                  x1="3"
                  y1="21"
                  x2="10"
                  y2="14"
                  stroke="#b8c0c9"
                  fill="none"
                ></line>
              </svg>
            </button>
          </Modal.Header>
          <Modal.Body className="modal-body-sm d-flex align-items-center justify-content-center flex-column">
            <Iframe
              room={room}
              user_unique_key="sdsdse23232"
              allAttendeeList={allAttendeeList}
              callDetails={callDetails}
            />
          </Modal.Body>
        </Modal>
        {minimizePopUpShow && <MinimizePopUp />}
      </>
    );
  } else {
    return (
      <>
        {header()}
        <div></div>
      </>
    );
  }
}
